import React, { useState, useRef } from 'react';
import { User } from 'lucide-react';
import logo from '../../assets/qlb.svg';
import { useAuth } from '../../contexts/AuthContext';
import ProfileDropdown from './ProfileDropdown';

const calculatorTypes = ['Crypto', 'Forex', 'Stocks', 'Futures'];

const NavigationBar = ({ activeType, onTypeChange }) => {
  const { isCheckingSubscription } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const profileBtnRef = useRef(null);

  return (
    <div className="sticky top-0 w-full z-50 bg-slate-950">
      <div className="flex justify-center w-full px-6">
        <nav className="h-16 flex items-center justify-between w-full max-w-5xl">
          <div className="flex items-center pt-0.5">
            <img src={logo} alt="QLB Logo" className="h-8 w-auto" />
            {/* Subscription check indicator */}
            {isCheckingSubscription && (
              <div className="ml-3 flex items-center text-slate-400">
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse mr-2"></div>
                <span className="text-xs">Checking subscription...</span>
              </div>
            )}
          </div>

          <div className="flex gap-8">
            {calculatorTypes.map((type) => (
              <button
                key={type}
                onClick={() => onTypeChange(type)}
                className="relative px-1 py-1.5 text-sm font-medium transition-colors group"
              >
                <span className={activeType === type ? 'text-slate-400' : 'text-slate-500 group-hover:text-slate-400'}>
                  {type}
                </span>
                <span className={`absolute bottom-0 left-0 w-full h-[0.5px] transition-all duration-200 ${activeType === type ? 'bg-slate-500' : 'bg-transparent group-hover:bg-slate-800'
                  }`} />
              </button>
            ))}
          </div>

          <div className="relative">
            <button
              ref={profileBtnRef}
              onClick={() => setDropdownOpen((prev) => !prev)}
              className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-slate-800 text-slate-400 hover:text-slate-300 transition-colors"
            >
              <User size={20} />
            </button>
            <ProfileDropdown
              isOpen={dropdownOpen}
              onClose={() => setDropdownOpen(false)}
              anchorRef={profileBtnRef}
            />
          </div>
        </nav>
      </div>
    </div>
  );
};

export default NavigationBar;